import styled from '@emotion/styled'

export const StyledTickets = styled.div`
    .buttons{
        margin: 35px 0;
    }
`;
